module.exports = __webpack_public_path__ + "img/icon_tips@3x.bf1613fd.png";